import { render, staticRenderFns } from "./FuelStorageTransactionDetail.vue?vue&type=template&id=588a5bb6&scoped=true&"
import script from "./FuelStorageTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./FuelStorageTransactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./FuelStorageTransactionDetail.vue?vue&type=style&index=0&id=588a5bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a5bb6",
  null
  
)

export default component.exports